import { get } from "lodash";

const getCartPreOrdersData = state => {
  return state.preOrdersCart.data;
};

const getCartPreOrdersPaginationDetails = state => {
  return state.preOrdersCart.paginationDetails;
};

const getPrescriptionCart = state => {
  const { data, fulfillmentsShippings, userLicenses } = state.prescriptionCart;
  return {
    data,
    fulfillmentsShippings,
    userLicenses,
  };
};

const getPrescriptionQueues = state => {
  return get(state, "prescriptionQueue", {});
};

const getPrescriptionQueuesCount = state => {
  return get(state, "prescriptionQueuesCount", {});
};

const getTaxCalculation = state => {
  return get(state, "taxCalculation", {});
};

export default {
  getCartPreOrdersData,
  getCartPreOrdersPaginationDetails,
  getPrescriptionCart,
  getPrescriptionQueues,
  getPrescriptionQueuesCount,
  getTaxCalculation,
};
